import React from 'react';
import './TheTeacherDashboard.css';
import ArticleIcon from '@mui/icons-material/Article';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';

export default function LatestAssessments({ managedAssessments, myAssessmentsLoading }) {
  return (
    <div className="latest-assessments h-100 d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center mb-4 ml-2">
        <h6 className="latest-title mb-0">Latest Papers</h6>
        <span className="dots-icon">⋯</span>
      </div>

      <div className="flex-grow-1">
        {!myAssessmentsLoading && managedAssessments && managedAssessments.length > 0 ? (
          managedAssessments.map((item, index) => {
            const date = new Date(item?.created_at);
            const formattedDate = date.toISOString().split('T')[0];
            return (
              <div
                className="assessment-row d-flex align-items-center py-3 px-2 mb-3 rounded"
                key={index}
              >
                <div className="row w-100 gx-3 align-items-center">
                  <div className="col-md-1 sm-1 col-2 text-center">
                    <ArticleIcon />
                  </div>
                  <div className="col-md-4 col-sm-6 col-10" style={{ paddingRight: 0 }}>
                    <span className="assessment-name" style={{ paddingRight: 0 }}>{item.title || "N/A"}</span>
                  </div>
                  <div className="col-md-3 sm-2 col-6 d-flex align-items-center">
                    {/* <CalendarMonthRoundedIcon className="me-1" /> */}
                    <span className="assessment-date">{formattedDate}</span>
                  </div>
                  <div className="col-md-3 col-sm-3 col-6 px-0 text-end me-n2">
                    <span className="badge published-badge" style={{ marginRight: 0 }}>{item.assessment_state || "N/A"}</span>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center py-5">
            {myAssessmentsLoading ? "Loading..." : "No Assessments found"}
          </div>
        )}
      </div>
    </div>
  );
}
